import { TourStep } from '../components/GuidedTour';

export const tourSteps: TourStep[] = [
    {
      // Step 1: Classroom Summary Tab Overview
      targetSelector: '.tab-button:first-child', // Target the first tab button
      content: 'This is the Classroom Summary tab. Here you can view an overview of all classrooms and their current student-to-teacher ratios. You can also move students and teachers between classrooms.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'classrooms'
    },
    {
      // Step 2: Section Row in Classroom Ratio Table
      targetSelector: '.summary-table-component:first-child .section-row:first-child',
      content: 'The section rows show the total number of teachers and students in the section, the overall ratio in that section, and the status of the section.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'classrooms'
    },
    {
      // Step 3: Classroom Row in Classroom Ratio Table
      targetSelector: '.summary-table-component:first-child tr:nth-child(3)',
      content: 'The classroom rows show the total number of teachers and students in the classroom, the overall ratio in that classroom, and the status of the classroom.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'classrooms'
    },
    {
      // Step 4: Student List Tooltip in Classroom Row
      targetSelector: '.summary-table-component:first-child .section-row:first-child + tr + tr td:nth-child(3) .count-with-tooltip, .custom-tooltip',
      content: 'When you hover over the number of students in a classroom, a list will pop up showing all students in this classroom. The <span class="move-icon"></span> icons next to each student name allow you to move them to a different classroom. The <span class="move-icon"></span> icon at the top of the list allows you to move all students in this classroom to a different classroom.',
      position: 'right',
      showTooltip: true,
      tooltipWidth: 300,
      switchTab: 'classrooms'
    },
    {
      // Step 5: Teacher List Tooltip in Classroom Row
      targetSelector: '.summary-table-component:first-child .section-row:first-child + tr + tr td:nth-child(4) .count-with-tooltip, .custom-tooltip',
      content: 'When you hover over the number of teachers in a classroom, a list will pop up showing all the teachers in this classroom. If there is a scheduled shift associated with the teacher, there will be a 🕛 icon and if you hover over it, it will display the shift start and end times. The <span class="move-icon"></span> icons on the left of each line allow you to move that teacher to a different classroom. The blue + icon at the top allows you to search for a teacher to add to this classroom.',
      position: 'left',
      showTooltip: true,
      tooltipWidth: 150,
      switchTab: 'classrooms'
    },
    {
      // Step 6: Ratio and Status for the First Classroom
      targetSelector: '.summary-table-component:first-child .section-row:first-child + tr + tr td:nth-child(5)',
      content: 'The status indicates if the section/classroom is properly staffed. "OVER" indicates more staff than required, "UNDER" indicates fewer staff than required. The section/classroom will also be color coded to reflect this status: red for understaffed and orange for overstaffed.',
      position: 'left',
      tooltipWidth: 300,
      switchTab: 'classrooms'
    },
    {
      // Step 7: Manual Refresh Button
      targetSelector: '#refresh-button',
      content: 'The dashboard will automatically refresh every minute. You can also manually refresh the dashboard by clicking this button.',
      position: 'left',
      tooltipWidth: 300,
      switchTab: 'classrooms'
    },
    {
      // Step 8: Staff Summary Tab Overview
      targetSelector: '.tab-button:nth-child(2)', // Target the second tab button
      content: 'This tab will show any staff that are clocked into When I Work but not signed into Smartcare, or vice versa.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'staff'
    },
    {
      // Step 9: Missing When I Work Clock-ins Section
      targetSelector: '.not-clocked-in-section',
      content: 'This section shows teachers who are checked into Smartcare but not clocked into When I Work. This likely means that the teacher was erroneously logged into Smartcare and you can log them out of Smartcare using the "Log Out of SmartCare" button. Alternatively, if the teacher forgot to clock in on the When I Work kiosk, please ask the teacher to punch in.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'staff'
    },
    {
      // Step 10: Missing SmartCare Check-in Section
      targetSelector: '.employee-container',
      content: 'This section displays teachers who are clocked into When I Work but not checked into SmartCare. You can check them into a classroom using the "Check Into SmartCare" button to properly track them in the system.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'staff'
    },
    {
      // Step 11: Classroom Details Tab Overview
      targetSelector: '.tab-button:nth-child(3)', // Target the third tab button
      content: 'The Classroom Details tab provides a more expanded view of each classroom, showing detailed information about students and teachers assigned to each room, allowing for easy management of staff and children.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'details'
    },
    {
      // Step 12: Section Container in Classroom Details
      targetSelector: '.section-container:nth-of-type(1)',
      content: 'Classrooms are grouped together by section.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'details'
    },
    {
      // Step 13: Section Header in Classroom Details
      targetSelector: '.section-container:nth-of-type(1) > div:nth-of-type(1)',
      content: 'Each section heading is color coded based on the overall section ratio status. It also displays the overall ratio, and the total number of teachers and students in the section.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'details'
    },
    {
      // Step 14: Individual Classroom Detail Card
      targetSelector: '.section-container:nth-of-type(1) .classroom-detail:nth-child(2)',
      content: 'Each classroom card is color-coded based on staffing status.',
      position: 'right',
      tooltipWidth: 300,
      switchTab: 'details'
    },
    {
      // Step 15: Classroom Header in Detail Card
      targetSelector: '.section-container:nth-of-type(1) .classroom-detail:nth-child(2) .classroom-header',
      content: 'At the top are some quick stats: student count, teacher count, and ratio.',
      position: 'right',
      tooltipWidth: 300,
      switchTab: 'details'
    },
    {
      // Step 16: Student Section in Classroom Detail
      targetSelector: '.section-container:nth-of-type(1) .classroom-detail:nth-child(2) .classroom-section:first-child',
      content: 'This section lists all students checked into the classroom. You can move students using the blue transfer icon or move all students using the blue icon next to the "Students" header.',
      position: 'right',
      tooltipWidth: 300,
      switchTab: 'details'
    },
    {
      // Step 17: Teacher Section in Classroom Detail
      targetSelector: '.section-container:nth-of-type(1) .classroom-detail:nth-child(2) .classroom-section:nth-child(2)',
      content: 'This section shows all teachers assigned to the classroom. You can add new teachers with the + icon, which will pull up a search box where you can search for teachers. You can also move individual teachers to another room using the <span class="move-icon"></span> icon next to their name.',
      position: 'right',
      tooltipWidth: 300,
      switchTab: 'details'
    },
    {
      // Step 18: Historical Ratios Tab Overview
      targetSelector: '.tab-button:nth-child(4)', // Target the fourth tab button
      content: 'The Historical Ratios tab allows you to review classroom and section staffing ratios over time. Use this tab to analyze trends and ensure compliance with staffing requirements.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 19: Historical Ratios Section Container
      targetSelector: '.tab-pane.active .section-container:nth-child(3)',
      content: 'Each section groups together related classrooms. Here you can see the historical ratios for all classrooms in this section.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 20: Section header timeline in Historical Ratios
      targetSelector: '.tab-pane.active .section-container:nth-child(3) .section-header',
      content: 'The timeline at the top of each section shows the overall ratio status for the section on an if-combined basis.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 21: Classroom timeline in Historical Ratios
      targetSelector: '.tab-pane.active .section-container:nth-child(3) > .classroom-row:nth-child(2)',
      content: 'The timeline for each class shows the ratio status for that classroom.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 22: Expand classroom details button in Historical Ratios
      targetSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) .expand-button',
      content: 'The plus icon next to each classroom name allows you to expand the classroom details, showing details for each teacher that was in the room.',
      position: 'right',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 23: Classroom details in Historical Ratios
      targetSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) + .individual-timelines-container',
      showEventSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) .expand-button',
      content: 'The deatiled view will show a Student timeline showing the number of students in the classroom throughout the day, and will show a timeline for each teacher that was present in the classroom during any portion of the day will be shown in the expanded view. The timeline will show when the teacher was present in blue, and when the teacher was on break in red.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 24: Teacher enter flag
      targetSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) + .individual-timelines-container .individual-row:nth-child(4) .classroom-transition.prev-classroom',
      showEventSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) .expand-button',
      content: 'If a teacher was in a different classroom before this one, a flag will show when what classroom they came from. You can click on this flag to go to the details of that other classroom.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 25: Tracher exit flag
      targetSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) + .individual-timelines-container .individual-row:nth-child(4) .classroom-transition.next-classroom',
      showEventSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) .expand-button',
      content: 'If a teacher left this classroom to go to a different classroom (rather then ending their shift), a flag will show when what classroom they went to . You can click on this flag to go to the details of that other classroom.',
      position: 'top',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 26: Shift start flag
      targetSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) + .individual-timelines-container .individual-row:nth-child(1) .shift-marker.start-marker ',
      showEventSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) .expand-button',
      content: 'If this teacher had a shift scheduled in When I Work, a green flag will show when the shift started.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 27: Shift end flag
      targetSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) + .individual-timelines-container .individual-row:nth-child(1) .shift-marker.end-marker ',
      showEventSelector: '.tab-pane.active .section-container:nth-child(3) .classroom-row:nth-child(2) .expand-button',
      content: 'If this teacher had a shift scheduled in When I Work, a red flag will show when the shift is/was scheduled to end.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'historical'
    },
    {
      // Step 28: Alarmed tab
      targetSelector: '.tab-button:nth-child(2)', // Target the second tab button
      content: 'If there is an issue on any of the taps (such as a classroom out of ration, or staffed not checked in properly), the tab will have an orange warning icon, it will putlse in red, and you might hear an alarm sound every 5 seconds. In this example, there are staff that are not checked in propertly, which is why this tab is showing an alarm.',
      position: 'bottom',
      tooltipWidth: 300,
      switchTab: 'staff'
    },
  ];
